/* eslint-disable @blitz/comment-syntax */
import { useStore } from '@nanostores/react';
import { chatStore } from '~/lib/stores/chat';
import { workbenchStore } from '~/lib/stores/workbench';
import { classNames } from '~/utils/classNames';
import { IconButton } from '~/components/ui/IconButton';

interface HeaderActionButtonsProps {}

export function HeaderActionButtons({}: HeaderActionButtonsProps) {
  const showWorkbench = useStore(workbenchStore.showWorkbench);
  const { showChat } = useStore(chatStore);
  const deviceView = useStore(workbenchStore.deviceView);
  const selectedView = useStore(workbenchStore.currentView);

  const canHideChat = showWorkbench || !showChat;

  return (
    <div className="flex bg-transparent">
      {selectedView === 'preview' ? (
        <>
          <span className="text-alpha-elements-textTertiary text-sm mr-2 flex items-center">Device Previews:</span>

          <Button onClick={() => workbenchStore.setDeviceView('mobile')} active={deviceView === 'mobile'}>
            <div className="i-ph:device-mobile-camera" />
          </Button>
          <Button onClick={() => workbenchStore.setDeviceView('tablet')} active={deviceView === 'tablet'}>
            <div className="i-ph:device-tablet-camera" />
          </Button>
          <Button onClick={() => workbenchStore.setDeviceView('desktop')} active={deviceView === 'desktop'}>
            <div className="i-ph:desktop" />
          </Button>
        </>
      ) : null}
      <IconButton
        icon="i-ph:arrows-out-line-horizontal text-lg text-white"
        disabled={!canHideChat}
        onClick={() => {
          if (canHideChat) {
            chatStore.setKey('showChat', !showChat);
          }
        }}
      >
        {/* <div className="i-ph:arrows-out-line-horizontal text-lg text-white" /> */}
      </IconButton>
      {/* <div className="w-[1px] bg-alpha-elements-borderColor" /> */}

      {/* <Button
          active={showWorkbench}
          onClick={() => {
            if (showWorkbench && !showChat) {
              chatStore.setKey('showChat', true);
            }

            workbenchStore.showWorkbench.set(!showWorkbench);
          }}
        >
          <div className="i-ph:code-bold" />
        </Button> */}
    </div>
  );
}

interface ButtonProps {
  active?: boolean;
  disabled?: boolean;
  children?: any;
  onClick?: VoidFunction;
}

function Button({ active = false, disabled = false, children, onClick }: ButtonProps) {
  return (
    <button
      className={classNames('flex items-center p-1.5', {
        'bg-alpha-elements-item-backgroundDefault hover:bg-alpha-elements-item-backgroundActive text-alpha-elements-textTertiary hover:text-alpha-elements-textPrimary':
          !active,
        'bg-alpha-elements-item-backgroundAccent text-alpha-elements-item-contentAccent': active && !disabled,
        'bg-alpha-elements-item-backgroundDefault text-alpha-gray-20 dark:text-alpha-white-20 cursor-not-allowed':
          disabled,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
